<div class="ui-fluid">
  <p-table
    [value]="values()"
    #dt
    [columns]="columns"
    [loading]="loading()"
    [resizableColumns]="true"
    loadingIcon="fa fa-spinner fa-pulse fa-3x fa-fw"
    styleClass="general-table"
    sortMode="single"
    (sortFunction)="customSort($event)"
    [customSort]="true"
    compareSelectionBy="equals"
    (onLazyLoad)="lazyLoadEvent($event)"
    (onRowExpand)="this.rowExpand.emit($event)"
    selectionMode="single"
    (onRowSelect)="onRowSelect($event, dt)"
    (onRowUnselect)="onRowUnSelect($event, dt)"
    dataKey="id"
    [lazy]="lazy()"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [paginatorPosition]="isMobile() ? 'top' : 'bottom'"
    columnResizeMode="fit"
    [paginator]="usePaginator()"
    [rowsPerPageOptions]="isMobile() ? undefined : rowsPerPageOptions()"
    paginatorDropdownAppendTo="body"
    [pageLinks]="pageLinkSize()"
    [virtualScroll]="virtualScroll()"
    [virtualScrollItemSize]="30"
    [scrollHeight]="scrollHeight()"
    [exportFunction]="exportFunction"
    [exportFilename]="exportFilename()"
    [lazyLoadOnInit]="false"
    [alwaysShowPaginator]="alwaysShowPaginator()"
    (onFilter)="this.filterEvent.emit($event)"
    [style.--white-space-style]="whiteSpaceStyle()"
    [showCurrentPageReport]="!isMobile()"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  >
    <!-- If no records are returned, display a message to indicate that. -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length">
          {{ 'COMMON.LABEL.NO_RECORDS_FOUND' | translate }}
        </td>
      </tr>
    </ng-template>
    <!-- This will display the embedded elements to the left of
    the paginator. -->
    <ng-template pTemplate="paginatorleft" />

    <!-- The right of the paginator has the filter/sort buttons to show those screens. -->
    @if (this._deviceService.isMobile()) {
      <ng-template pTemplate="paginatorright">
        @if (totalRecords) {
          <div
            [translate]="'COMMON.LABEL.TOTAL_RECORDS_ACROSS_PAGES'"
            [translateParams]="{
              totalRecords: totalRecords,
              totalPages: totalPages,
            }"
          ></div>
        }
      </ng-template>
    }

    <!-- Grid title and caption criteria -->
    @if ((header() || includeExportCSV) && isMobileDevice()) {
      <ng-template pTemplate="caption">
        <div class="grid-helper" style="height: 40px">
          <label>{{ header() }}</label>
          @if (includeExportCSV) {
            <app-export
              [selectedItems]="selectedItems"
              (clearSelections)="clearSelections()"
              (exportCSV)="exportCSVFunction()"
            />
          }
        </div>
      </ng-template>
    }

    <!-- Setup the header columns and their filter components. -->
    <ng-template pTemplate="header" let-columns>
      <tr>
        @if (useRowExpand() === true) {
          <th style="width: 5%"></th>
        }
        @for (col of columns; track trackByColumn($index, col)) {
          <th
            [pSortableColumn]="col.sortable ? col.field : null"
            [class]="getClass(col, true)"
            pResizableColumn
          >
            <app-table-column-header [column]="col" />
          </th>
        }
      </tr>

      @if (filterable() && !this._deviceService.isMobile()) {
        <tr>
          @if (useRowExpand() === true) {
            <th style="width: 5%"></th>
          }
          @for (col of columns; track trackByColumn($index, col)) {
            <th pResizableColumn [style.width]="col.width">
              @if (col.type !== 'lookup') {
                <app-table-filter
                  [col]="col"
                  (filterEvent)="handleFilter(col, $event)"
                />
              }
            </th>
          }
        </tr>
      }
    </ng-template>

    <ng-template pTemplate="loadingbody" let-columns="columns">
      <tr style="height: 34px">
        @for (col of columns; track col) {
          <td>
            <div class="loading-text"></div>
          </td>
        }
      </tr>
    </ng-template>

    <ng-template
      pTemplate="body"
      let-rowData
      let-columns="columns"
      let-expanded="expanded"
    >
      @if (isMobile()) {
        <tr [pSelectableRow]="rowData" class="mobile-row">
          @for (col of columns; track col) {
            @if (col.mobileHeader) {
              <td>
                @if (!col.hideMobileLabel) {
                  <span [translate]="col.mobileHeader"></span>
                }
                @if (col.type === 'calendar') {
                  <span>{{
                    rowData[col.field]
                      | date: (col.dateFormat ? col.dateFormat : 'MM/dd/yyyy')
                  }}</span>
                } @else {
                  @if (col.formatPattern === 'hyperlink') {
                    <span class="button-col">
                      <a
                        href
                        (click)="
                          changeView($event, {
                            data: rowData,
                            type: col.viewType,
                          })
                        "
                        >{{ rowData[col.field] }}</a
                      >
                    </span>
                  }
                  @if (col.formatPattern === 'actionButton') {
                    <span class="button-col">
                      <button
                        pButton
                        class="action-button"
                        label="{{ rowData[col.actionTextField] }}"
                        icon="fa fa-fw fa-plus-circle"
                        (click)="
                          executeActionButton($event, {
                            data: rowData,
                            type: col.viewType,
                          })
                        "
                      ></button>
                    </span>
                  }
                  @if (col.formatPattern === 'copyableText') {
                    <span class="button-col">
                      test
                      {{ rowData[col.field] }}
                      <button
                        pButton
                        class="copyable-text"
                        icon="fa fa-fw fa-clone"
                        (click)="copyRowText(rowData[col.field])"
                      ></button>
                    </span>
                  }
                  @if (
                    col.formatPattern !== 'hyperlink' &&
                    col.formatPattern !== 'actionButton' &&
                    col.subField !== null &&
                    col.subField !== undefined
                  ) {
                    <span>{{ rowData[col.field][col.subField] }}</span>
                  }
                  @if (
                    col.formatPattern !== 'hyperlink' &&
                    col.formatPattern !== 'actionButton' &&
                    (col.subField === null || col.subField === undefined)
                  ) {
                    <span>{{ rowData[col.field] }}</span>
                  }
                }
              </td>
            }
          }
        </tr>
      }

      @if (isNonMobile()) {
        <tr
          [pSelectableRow]="rowData"
          class="nonmobile-row"
          (dblclick)="changeView($event, { data: rowData })"
        >
          @if (useRowExpand() === true) {
            <td style="width: 5%" class="row-expand-cell">
              <a href="#" [pRowToggler]="rowData">
                <i
                  [ngClass]="
                    expanded
                      ? 'fa fa-fw fa-chevron-circle-down'
                      : 'fa fa-fw fa-chevron-circle-right'
                  "
                ></i>
              </a>
            </td>
          }
          @for (col of columns; track trackByColumn($index, col)) {
            <td [class]="getStyleClass(col)">
              @if (col.type === 'calendar') {
                <span>{{
                  rowData[col.field]
                    | date: (col.dateFormat ? col.dateFormat : 'MM/dd/yyyy')
                }}</span>
              } @else {
                @if (col.formatPattern === 'hyperlink-url') {
                  <span>
                    <a href="{{ rowData[col.field] }}" target="_blank">
                      @if (rowData[col.field]) {
                        <img
                          src="assets/images/link.png"
                          style="width: 10px; height: 10px"
                        />
                      }
                    </a>
                  </span>
                }
                @if (col.formatPattern === 'hyperlink') {
                  <span class="button-col">
                    <a
                      href
                      (click)="
                        changeView($event, {
                          data: rowData,
                          type: col.viewType,
                        })
                      "
                      >{{ rowData[col.field] }}</a
                    >
                  </span>
                }
                @if (col.formatPattern === 'actionButton') {
                  <span class="button-col">
                    <button
                      pButton
                      class="action-button"
                      label="{{ rowData[col.actionTextField] }}"
                      icon="fa fa-fw fa-plus-circle"
                      (click)="
                        executeActionButton($event, {
                          data: rowData,
                          type: col.viewType,
                        })
                      "
                    ></button>
                  </span>
                }
                @if (col.formatPattern === 'copyableText') {
                  <span>
                    {{ rowData[col.field] }}
                    <button
                      pButton
                      class="copyable-text"
                      icon="fa fa-fw fa-clone"
                      (click)="copyRowText(rowData[col.field])"
                      pTooltip="{{ 'COMMON.TOOLTIPS.COPY' | translate }}"
                    ></button>
                  </span>
                }
                @if (col.type === 'checkbox') {
                  <p-checkbox
                    class="nav-checkbox"
                    [ngModel]="rowData[col.field]"
                    [binary]="true"
                    [disabled]="true"
                  />
                }
                @if (col.formatPattern === 'icons') {
                  <span>
                    @for (i of rowData[col.field]; track i) {
                      <span id="icon-container"><i class="{{ i }}"></i></span>
                    }
                  </span>
                }
                @if (
                  col.formatPattern === 'text' &&
                  (col.subField === null || col.subField === undefined) &&
                  col.header !== 'Note'
                ) {
                  <span>{{ rowData[col.field] }}</span>
                }
                @if (
                  col.formatPattern === 'text_lower' &&
                  (col.subField === null || col.subField === undefined)
                ) {
                  <span>{{ rowData[col.field] | lowercase }}</span>
                }
                @if (col.header === 'Note') {
                  <span>{{ rowData[col.field] | noteEntryString }}</span>
                }
                @if (
                  col.formatPattern === 'text' &&
                  col.subField !== null &&
                  col.subField !== undefined &&
                  col.header !== 'Note'
                ) {
                  <span>{{ rowData[col.field][col.subField] }}</span>
                }
                @if (
                  col.formatPattern === 'number' &&
                  (col.subField === null || col.subField === undefined)
                ) {
                  <span class="number-column">{{
                    rowData[col.field] | number
                  }}</span>
                }
                @if (
                  col.formatPattern === 'number' &&
                  col.subField !== null &&
                  col.subField !== undefined
                ) {
                  <span class="number-column">{{
                    rowData[col.field][col.subField] | number
                  }}</span>
                }
                @if (
                  col.formatPattern === 'currency' &&
                  (col.subField === null || col.subField === undefined)
                ) {
                  <span class="number-column">{{
                    rowData[col.field] | currency
                  }}</span>
                }
                @if (
                  col.formatPattern === 'currency' &&
                  col.subField !== null &&
                  col.subField !== undefined
                ) {
                  <span class="number-column">{{
                    rowData[col.field][col.subField] | currency
                  }}</span>
                }
                @if (
                  col.formatPattern === 'decimal' &&
                  (col.subField === null || col.subField === undefined)
                ) {
                  <span class="number-column">{{
                    rowData[col.field] | number: col.decimalFormat
                  }}</span>
                }
                @if (
                  col.formatPattern === 'decimal' &&
                  col.subField !== null &&
                  col.subField !== undefined
                ) {
                  <span class="number-column">{{
                    rowData[col.field][col.subField] | number: col.decimalFormat
                  }}</span>
                }
              }
            </td>
          }
        </tr>
      }
    </ng-template>

    @if (useRowExpand()) {
      <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
        <tr>
          <td [attr.colspan]="columns.length + 1" class="row-expand">
            <div>
              <ng-content select="[row-expand]" />
            </div>
          </td>
        </tr>
      </ng-template>
    }
  </p-table>
</div>
